import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExtModalComponent } from '../ext-modal/ext-modal.component';
import { InactivityService } from '../../service/components/inactivity.service';
import { AuthService } from '../../service/auth/auth.service';

/**
 * Componente que muestra un modal cuando el usuario ha estado inactivo por un tiempo determinado.
 * Permite al usuario extender su sesión o cerrarla.
 */
@Component({
  selector: 'app-inactivity-modal',
  standalone: true,
  imports: [CommonModule, ExtModalComponent],
  template: `
    <app-ext-modal
      [visible]="showPrompt"
      [title]="'Sesión inactiva'"
      [paragraph]="
        'Tu sesión ha estado inactiva por un tiempo. ¿Deseas continuar o cerrar la sesión?'
      "
      [type]="'dude'"
      [confirmText]="'Continuar sesión'"
      [cancelText]="'Cerrar sesión'"
      (onConfirm)="extendSession()"
      (onCancel)="logout()"
      (onClose)="logout()"
    ></app-ext-modal>
  `,
  styles: [],
})
export class InactivityModalComponent implements OnInit {
  /** Indica si se debe mostrar el modal de inactividad */
  showPrompt = false;

  constructor(
    private inactivityService: InactivityService,
    private authService: AuthService
  ) {}

  /**
   * Inicializa la suscripción al servicio de inactividad para mostrar/ocultar el modal
   */
  ngOnInit() {
    this.inactivityService.showPrompt$.subscribe(
      (show) => (this.showPrompt = show)
    );
  }

  /**
   * Extiende la sesión del usuario llamando al servicio de inactividad
   */
  extendSession() {
    this.inactivityService.extendSession();
  }

  /**
   * Cierra la sesión del usuario:
   * 1. Oculta el modal de inactividad
   * 2. Llama al servicio de autenticación para cerrar sesión
   */
  logout() {
    this.showPrompt = false;
    this.authService.signOut();
  }
}
